// Landing "Cronometraggio gare" (/it/cronometraggio-gare): modulo di preventivo nella hero.
// Invia allo stesso endpoint della pagina contatti (problem_type = timing_service), quindi
// email, ticket, attribuzione gclid/UTM e conversione Google Ads restano gli stessi.
var attribution = require("../../components/attribution");
var leadTracking = require("../../components/lead-tracking");

var TURNSTILE_SRC = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit&onload=idcQuoteTurnstileReady";

$(document).ready(function () {
	var $form = $("#timing-quote-form");
	if (!$form.length) {
		return;
	}

	var form = $form.get(0);
	var $alert = $form.find(".tp-quote__alert");
	var $submit = $form.find(".tp-quote__submit");
	var submitLabel = $submit.text();
	var captchaEl = document.getElementById("tq-turnstile");
	var turnstileRequested = false;
	var widgetId = null;
	var submitPending = false;
	var sending = false;

	function showAlert(text) {
		$alert.text(text).prop("hidden", !text);
	}

	// Turnstile pesa ~100 KB: lo carichiamo solo quando l'utente inizia a usare il modulo.
	function loadTurnstile() {
		if (turnstileRequested) {
			return;
		}
		turnstileRequested = true;
		window.idcQuoteTurnstileReady = function () {
			widgetId = window.turnstile.render(captchaEl, {
				sitekey: captchaEl.getAttribute("data-sitekey"),
				theme: "light",
				callback: function () {
					if (submitPending) {
						submitPending = false;
						send();
					}
				}
			});
		};
		var script = document.createElement("script");
		script.src = TURNSTILE_SRC;
		script.async = true;
		document.head.appendChild(script);
	}

	$form.one("focusin pointerdown", loadTurnstile);

	function token() {
		return $form.find("input[name='cf-turnstile-response']").val();
	}

	// L'endpoint accetta un solo campo "message": i dettagli della gara vanno nel testo.
	function buildMessage() {
		var lines = [form.getAttribute("data-msg-intro")];
		$form.find("[data-label]").each(function () {
			var value = $.trim($(this).val());
			if (value) {
				lines.push($(this).attr("data-label") + ": " + value);
			}
		});
		return lines.join("\n");
	}

	function send() {
		if (sending) {
			return;
		}
		sending = true;
		showAlert("");
		$submit.prop("disabled", true).text(form.getAttribute("data-msg-sending"));
		$form.find("input[name='message']").val(buildMessage());

		var data = $form.serializeArray();
		var campaign = attribution.get();
		Object.keys(campaign).forEach(function (key) {
			data.push({ name: key, value: campaign[key] });
		});

		$.post("/api/en/v1/send-email", data)
			.done(function () {
				leadTracking.track("timing_service", $("#tq-email").val());
				$form.prop("hidden", true);
				$(".tp-quote__done").prop("hidden", false).trigger("focus");
			})
			.fail(function () {
				showAlert(form.getAttribute("data-msg-error"));
				// il token Turnstile vale una sola volta: ne serve uno nuovo per riprovare
				if (window.turnstile && widgetId !== null) {
					window.turnstile.reset(widgetId);
				}
			})
			.always(function () {
				sending = false;
				$submit.prop("disabled", false).text(submitLabel);
			});
	}

	// La validazione dei campi obbligatori la fa il browser (attributi required/type) prima di "submit".
	$form.on("submit", function (e) {
		e.preventDefault();
		if (token()) {
			send();
			return;
		}
		// Verifica anti-spam non ancora completata: l'invio parte da solo appena arriva il token.
		submitPending = true;
		loadTurnstile();
		showAlert(form.getAttribute("data-msg-captcha"));
	});

	$("#timing-page").on("click", "a[href^='tel:']", function () {
		if (typeof window.gtag === "function") {
			window.gtag("event", "phone_click", { call_location: $(this).attr("data-call-location") || "" });
		}
	});
});
